import { useState } from "react";
import { submitFeedback } from "@/common/services/feedbackService";
import { useAccessToken, useRefreshToken } from "@/common/context/AuthContext";
import styles from "./FeedbackQuestion.module.css";

interface FeedbackQuestionProps {
  messageId?: number;
  sessionId?: string;
  agent?: string;
}

const FeedbackQuestion = ({ messageId, sessionId, agent }: FeedbackQuestionProps) => {
  const [isFeedbackSubmitted, setIsFeedbackSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState<1 | 2 | null>(null);
  const getAccessToken = useAccessToken();
  const refreshToken = useRefreshToken();

  const handleFeedback = async (feedback: 1 | 2) => {
    if (isFeedbackSubmitted || isSubmitting || !messageId) return;

    setIsSubmitting(true);
    setFeedback(feedback);
    try {
      const accessToken = await getAccessToken();
      
      if (!sessionId) {
        console.error("No session ID available for feedback");
        setIsFeedbackSubmitted(true);
        return;
      }

      await submitFeedback(
        {
          sessionId,
          messageId,
          feedback,
          agent,
        },
        accessToken,
        refreshToken
      );

      setIsFeedbackSubmitted(true);
    } catch (error) {
      console.error("Failed to submit feedback:", error);
      // Still mark as submitted to prevent repeated attempts
      setIsFeedbackSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (isFeedbackSubmitted)
    ? (feedback === 1
      ? <p className={styles.feedbackQuestionText}>Tack för din feedback!</p>
      : <p className={styles.feedbackQuestionText}>Jag vill gärna att du får den hjälp du behöver. Prova gärna att formulera om din fråga, eller säg till om du vill ha kontakt med kundservice.</p>
    )
    : (
      <>
        <p className={styles.feedbackQuestionText}>Fick du svar på din fråga?</p>
        <div className={styles.buttonWrapper}>
          <button
            className={styles.feedbackButton}
            aria-label="Svaret hjälpte"
            onClick={() => handleFeedback(1)}
            disabled={isSubmitting}
          >
            Det hjälpte 👍
          </button>
          <button
            className={styles.feedbackButton}
            aria-label="Mer hjälp behövs"
            onClick={() => handleFeedback(2)}
            disabled={isSubmitting}
          >
            Mer hjälp 💡
          </button>
        </div>
      </>
    );
};

export default FeedbackQuestion;